// MN-8955: split the "Unable to connect to server" Honeybadger cluster by
// sub-type at the point of report. MN-8803's buildNetworkConnectionError leaves
// a low-cardinality `.networkSubType` on the escaped sentinel; this reads it and
// returns the notify() options that (a) surface the sub-type in HB context and
// (b) pin a `network-error:<subtype>` fingerprint so the single byte-identical
// message no longer collapses every sub-type into one bucket.
//
// Centralizing the prefix here keeps the two downstream reporters
// (create-react-root, checkout-observability) from drifting apart.
export const NETWORK_ERROR_FINGERPRINT_PREFIX = "network-error:";

type NetworkErrorReportOptions = {
  fingerprint?: string;
  context?: { networkSubType: string };
};

// Returns an empty object for errors without a string `.networkSubType`, so
// callers can spread the result unconditionally without branching.
export const networkErrorReportOptions = (error: unknown): NetworkErrorReportOptions => {
  const subType = (error as { networkSubType?: unknown } | null | undefined)?.networkSubType;
  if (typeof subType !== "string" || subType.length === 0) return {};
  return {
    fingerprint: `${NETWORK_ERROR_FINGERPRINT_PREFIX}${subType}`,
    context: { networkSubType: subType }
  };
};
